import * as React from 'react';
import styles from './ColorGradient.module.css';

export function ColorGradient() {
  return <div className={styles.yellowGradBg} />;
}
